module.exports = __webpack_public_path__ + "static/media/wine-bottle.ffbd3f05.svg";